<template>
  <v-container fluid class="px-12 py-4" v-if="organization">
    <v-row>
      <v-col cols="12" lg="8">
        <breadcrumbs></breadcrumbs>
        <h1>Structure</h1>
        <v-divider class="my-3"></v-divider>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="8">
        <v-card outlined>
          <v-card-text>
            <v-list>
              <v-subheader
                ><span class="body-1">Organization Structure</span></v-subheader
              >
              <v-list-item-group>
                <v-list-item @click="navigateToExport('department')">
                  <v-list-item-avatar>
                    <v-icon color="accent" small>fas fa-download</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      >Epic Export - Departments</v-list-item-title
                    >
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-list-item-action-text>xlsx</v-list-item-action-text>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item @click="navigateToExport('location')">
                  <v-list-item-avatar>
                    <v-icon color="accent" small>fas fa-download</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      >Epic Export - Locations</v-list-item-title
                    >
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-list-item-action-text>xlsx</v-list-item-action-text>
                  </v-list-item-action>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Breadcrumbs from "@/views/Breadcrumbs";

export default {
  components: {
    Breadcrumbs,
  },
  computed: {
    ...mapState({
      organization: state => state.organization.record,
      organizationId: state => state.session.user.organizationId,
    }),
  },
  async created() {
    try {
      await this.getOrganization(this.organizationId);
    } catch (e) {
      console.error(e);
      this.$notifyError({ message: "Unable to load organization data" });
    }
  },
  methods: {
    navigateToExport(exportType) {
      window.location.href = `/api/${exportType}/download`;
    },
    ...mapActions({
      getOrganization: "organization/getByOrganizationId",
    }),
  },
};
</script>
